module.exports = __webpack_public_path__ + "media/bgm.36b30c96.mp3";